// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bd-b";
export var colorBlue = "_bd-8";
export var colorDot = "_bd-0";
export var colorDotLarge = "_bd-2";
export var colorDotSmall = "_bd-1";
export var colorGreen = "_bd-7";
export var colorGrey = "_bd-3";
export var colorOrange = "_bd-5";
export var colorPink = "_bd-a";
export var colorPurple = "_bd-9";
export var colorRed = "_bd-4";
export var colorYellow = "_bd-6";